import { render, staticRenderFns } from "./SupervisedModal.vue?vue&type=template&id=b810f8d8&scoped=true"
import script from "./SupervisedModal.vue?vue&type=script&lang=js"
export * from "./SupervisedModal.vue?vue&type=script&lang=js"
import style0 from "./SupervisedModal.vue?vue&type=style&index=0&id=b810f8d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b810f8d8",
  null
  
)

export default component.exports